import { GET_COLLECTION_BY_SLUG_QUERY as PUBLIC_GET_COLLECTION_BY_SLUG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc-external.dfc.new';
import { GET_COLLECTION_BY_SLUG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/discovery/studio/rpc/CollectionsRpc.dfc.new';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { mapAppliedFiltersForRpc } from '../../search-results/utils/searchMappers';

/**
 * Adapts a DS `getCollectionBySlug` listing card to the personalization
 * `ListingCard` the storefront grid/section components render. The two are
 * wire-compatible mkpl-search models generated under different namespaces.
 *
 * The `as unknown` cast is required because the generated types are nominally
 * distinct. Fields audited for compatibility (as of this migration):
 * - shared: listingId, providerName, companyName, description, iconUrl,
 *   installCount, betaStage, displayTag, displayTagLabel, products, reviewSummary
 * - required by personalization but optional on DS (defaulted here): listingName, slug
 * - personalization-only relevance fields DS omits (defaulted here):
 *   highlights, recommendationSources, listingTrellisIcon
 * If a new required field is added to the personalization `ListingCard`, this
 * cast will hide it — re-audit here when that type changes.
 */
function adaptDSListingCard(card) {
  var _card$listingName, _card$slug;
  return Object.assign({}, card, {
    listingName: (_card$listingName = card.listingName) !== null && _card$listingName !== void 0 ? _card$listingName : '',
    slug: (_card$slug = card.slug) !== null && _card$slug !== void 0 ? _card$slug : '',
    highlights: [],
    recommendationSources: [],
    listingTrellisIcon: undefined
  });
}

/**
 * Fetches a collection's listing cards from mkpl-discovery-studio
 * `getCollectionBySlug`, scoped to the given product types. Used to load the
 * per-section cards on DS-backed collection surfaces (umbrella sections,
 * agents product home) in place of a personalization search.
 */
export function useDiscoveryCollectionListings({
  slug,
  productTypes,
  length,
  skip
}) {
  var _data$result$items, _data$result;
  const {
    data,
    loading,
    error
  } = useAppContextQuery({
    app: GET_COLLECTION_BY_SLUG_QUERY,
    public: PUBLIC_GET_COLLECTION_BY_SLUG_QUERY,
    options: {
      skip: skip || !slug,
      variables: {
        slug,
        offset: 0,
        limit: length,
        filter: mapAppliedFiltersForRpc([{
          field: 'PRODUCT_TYPE',
          dataType: 'STRING',
          values: productTypes
        }]),
        sorts: []
      }
    }
  });
  return {
    cards: ((_data$result$items = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.items) !== null && _data$result$items !== void 0 ? _data$result$items : []).map(adaptDSListingCard),
    loading,
    error
  };
}